<template>
		<v-container fluid>
				<div class="base-page">
					<logo-with-title :title="$t('selectInstitute')"/>
						<v-col>
							<v-card-text>
								<h2 class="text-center primary--text font-weight-medium">{{$t('hello')}} {{ auth.name }}</h2>
								<h3 class="text-center textColor--text mt-5 font-weight-regular">{{$t('mustSelectInstitution')}}</h3>
							</v-card-text>
							<v-card-actions class="d-flex flex-column mt-8">
								<v-row v-for="(mosadData, index) in complexMosad" :key="index">
									<v-col>
										<v-btn outlined color = "primary" class="base-rounded" @click="selectMosad(mosadData.mosad)">
											{{ mosadData.mosad }}
										</v-btn>
									</v-col>
								</v-row>
								<v-row>
									<v-col>
										<v-btn color="btnColor" rounded block :href="`/logout${search}`">
											<span class="px-2 font-weight-bold text-h5">{{ $t("logout") }}</span>
										</v-btn>
									</v-col>
								</v-row>
							</v-card-actions>
						</v-col>
					<lang-select/>
				</div>
		</v-container>
</template>

<script>
import ProjectModule from "src/store/modules/Project.module";
import CloseAppLogo from "@/components/CloseAppLogo";
import UserModule from "src/store/modules/User.module";
import LogoWithTitle from "@/components/LogoWithTitle";
import LangSelect from "@/components/LangSelect";


export default {
	components: {
		LangSelect,
		LogoWithTitle,
	},
	data: () => ({
		showError: false,
		disabled: false,
		form: {
			email: "",
			password: ""
		},
		errors: {}
	}),
	computed: {
		auth() {
			return this.$store.state.AuthModule.user;
		},
		search() {
			return location.search;
		},
		complexMosad() {
			return JSON.parse(this.auth.edu_complex_mosad);
		}
	},
	async created() {
		const id = this.$route.query.p;
		if (id) {
			await this.$store.dispatch(ProjectModule.types.GET, id);
		}
		// this.setProjectBackgroundImage();
	},
	methods: {
		setProjectBackgroundImage() {
			document.querySelector(".background-image").style.background =
				"url(" + this.project.image + ")";
		},
		async doLogin() {
			window.location = "/oauth/authorize" + this.search;
		},
		async selectMosad(mosad) {
			await this.$store.dispatch(UserModule.types.SELECT_MOSAD, { id: this.auth.id, edu_mosad: mosad });
			window.location = "/oauth/authorize" + this.search;
		}
	}
};
</script>

<style lang="scss" scoped>
@import "./../../sass/generic";

.background-image {
	z-index: -1 !important;
	position: fixed;
	height: 100%;
	width: 100%;
	left: 0;
	top: 0;
	webkit-background-size: cover !important;
	-moz-background-size: cover !important;
	-o-background-size: cover !important;
	background-size: cover !important;
	background-position: center !important;
	background-repeat: no-repeat !important;
	filter: blur(6px);
	-webkit-filter: blur(6px);
	transform: scale(1.03);
}

.page {
	width: 90%;
	margin: auto;
	background-color: $background;

	@include responsive($mobile) {
		max-width: $mobile !important;
		max-height: $mobile-height;
	}

	.project-name {
		&--col {
			padding: 0;

			div {
				height: 40px;
				width: 220px;
				background: #4595cc 0 0 no-repeat padding-box;
				border-radius: 0 0 20px 20px;
				opacity: 1;
			}
		}
	}
}
</style>
